import React, { useEffect, useCallback, useState } from "react";
import {
  Button,
  CardContent,
  CircularProgress,
  List,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import * as actions from "../actions";
import * as ru from "../util/reportUtils";
import PageContainer, { CardPageItem, PageItem } from "../custom/Page";
import UserListItem from "./components/Reports/ReportManagersAndAgents/UserListItem";
import HeaderManagersAndAgents from "./components/Reports/ReportManagersAndAgents/HeaderManagersAndAgents"

export const TOGGLE_ALL_ENUM = {
  open: "openAll",
  close: "closeAll",
};

const useStyles = makeStyles((theme) => ({
  mainHeaderRow: {
    "& > th": {
      borderBottom: "3px solid #333",
      color: "#AAA",
    },
  },
  mainRow: {
    "& > *": {
      borderBottom: "unset",
    },
    "& > td:first-child": {
      width: 10,
      paddingLeft: 10,
      paddingRight: 0,
    },
  },
  detailBox: {
    backgroundColor: "#151515",
    paddingLeft: 50,
  },
  detailHeaderRow: {
    "& > th": {
      borderBottom: "3px solid #222",
      color: "#AAA",
    },
  },
  detailRow: {
    "& > td": { borderBottom: "1px solid #222" },
  },
  iconManager: {
    color: theme.palette.primary.main,
  },
  iconAgent: {
    color: "white",
  },
  iconCustomer: {
    color: "#666",
  },
  listTitle: {
    color: "#999",
    paddingLeft: 16,
  },
  contractCount: {
    color: theme.palette.primary.main,
  },
}));

const ManagerAndAgentsPage = ({
  currentUser,
  getConfig,
  enableHeader = true,
  enableInfoValues = true,
  history
}) => {
  const [loading, setLoading] = useState(true);
  const [simpleCurrentUser, setSimpleCurrentUser] = useState({});
  const [toggleAll, setToggleAll] = useState(false);
  const [user, setUser] = useState({
    managers: [],
    agents: [],
    customers: [],
    contracts: [],
    received: {},
    ui: {
      isListOpen: false,
    },
  });
  const classes = useStyles();

  const getReport = useCallback(async () => {
    setLoading(true);

    const simpleCurrentUser = await ru.simplifyUser(
      JSON.parse(JSON.stringify(currentUser)),
      [],
      null
    );

    const user = await actions.getUserHierarchy(currentUser.id);
    setUser(user);

    setSimpleCurrentUser(simpleCurrentUser);
    setLoading(false);
  }, [currentUser]);

  useEffect(() => {
    const fetchData = async () => {
      await getConfig();
      await getReport();
    };

    fetchData();
  }, [getConfig, getReport]);

  const handleOpenAll = () => {
    setToggleAll(TOGGLE_ALL_ENUM.open);
  };

  const handleCloseAll = () => {
    setToggleAll(TOGGLE_ALL_ENUM.close);
  };

  if (loading)
    return (
      <div style={{ width: "100%", textAlign: "center" }}>
        <CircularProgress style={{ marginTop: !enableHeader ? "5%" : "25%" }} />
      </div>
    );

  return (
    <PageContainer full>
      {enableHeader && (
        <>
          <HeaderManagersAndAgents onBack={() => history.goBack()} />
          <CardPageItem raised>
            <CardContent>
              <Button
                variant="outlined"
                size="small"
                onClick={(e) => handleOpenAll()}
              >
                <FormattedMessage id="app.open.all" />
              </Button>{" "}
              <Button
                variant="outlined"
                size="small"
                onClick={(e) => handleCloseAll()}
              >
                <FormattedMessage id="app.close.all" />
              </Button>
            </CardContent>
          </CardPageItem>
        </>
      )}
      <PageItem>
        <>
          {enableHeader && (
            <Typography
              variant="caption"
              classes={{ root: classes.listTitle }}
            >
              <FormattedMessage id="app.hierarchy.below" />
            </Typography>
          )}
          <List>
            <UserListItem
              currentUser={simpleCurrentUser}
              user={user}
              classes={classes}
              toggleAll={toggleAll}
              enableInfoValues={enableInfoValues}
            />
          </List>
        </>
      </PageItem>
    </PageContainer>
  );
};

export default connect(
  (state) => ({ currentUser: state.user.user.me, config: state.config }),
  actions
)(ManagerAndAgentsPage);
